<template>
  <div>
    <TurnDownQuoteModalPrice
      v-if="step === turnDownSteps.PRICE"
      :schedule_id="schedule_id"
      :next="goToNextStep"
    />
    <TurnDownQuoteModalBackup
      v-if="step === turnDownSteps.BACKUP"
      :schedule_id="schedule_id"
      :next="goToNextStep"
    />
    <TurnDownQuoteModalReject
      v-if="step === turnDownSteps.REJECT"
      :name="name"
      :contractor-user-id="contractorUserId"
      :property_id="property_id"
      :schedule_id="schedule_id"
      :recommendation_id="recommendation_id"
      :required-service_id="requiredService_id"
    />
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import { mapActions, mapState } from 'vuex';
import _ from 'lodash';
import TurnDownQuoteModalPrice from './components/TurnDownQuoteModalPrice.vue';
import TurnDownQuoteModalBackup from './components/TurnDownQuoteModalBackup.vue';
import TurnDownQuoteModalReject from './components/TurnDownQuoteModalReject.vue';
import { SCHEDULES__SUBMIT_QUOTE_ISSUE } from '../../store/types';

export default {
  name: 'TurnDownQuoteModal',
  components: {
    TurnDownQuoteModalPrice,
    TurnDownQuoteModalBackup,
    TurnDownQuoteModalReject,
  },
  props: {
    name: VueTypes.string.isRequired,
    contractorUserId: VueTypes.number.isRequired,
    //eslint-disable-next-line vue/prop-name-casing
    property_id: VueTypes.number.isRequired,
    //eslint-disable-next-line vue/prop-name-casing
    schedule_id: VueTypes.number,
    //eslint-disable-next-line vue/prop-name-casing
    recommendation_id: VueTypes.number,
    //eslint-disable-next-line vue/prop-name-casing
    requiredService_id: VueTypes.number,
  },
  data() {
    return {
      turnDownSteps: {
        PRICE: 'price',
        BACKUP: 'backup',
        REJECT: 'reject',
      },
      // manualquotes have a schedule_id, recommended and required do not.
      step: this.schedule_id ? 'price' : 'reject',
    };
  },
  computed: {
    ...mapState(['schedules']),
  },
  methods: {
    ...mapActions([SCHEDULES__SUBMIT_QUOTE_ISSUE]),
    goToNextStep({ schedule_id, issues } = {}) {
      const { BACKUP, REJECT } = this.turnDownSteps;
      if (this.step === BACKUP) {
        this.step = REJECT;
        return;
      }

      const { price } = this.schedules.schedulesById[this.schedule_id].manualquote;
      this[SCHEDULES__SUBMIT_QUOTE_ISSUE]({ schedule_id, issues });

      if (issues.pricing && _.get(price, 'amount_backup', false)) {
        this.step = BACKUP;
      } else {
        this.step = REJECT;
      }
    },
  },
};
</script>
